import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import Tab from './tab';
import { tabContainerVariants } from './services';
import styles from './tabs.module.scss';
import { Button } from 'antd';

const arrowLeftIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_62074_60433)">
      <path
        d="M3.82864 8.57107L11.0238 15.7638C11.3395 16.0787 11.851 16.0787 12.1675 15.7638C12.4832 15.4489 12.4832 14.9374 12.1675 14.6225L5.54309 8.00043L12.1667 1.37841C12.4824 1.06349 12.4824 0.551973 12.1667 0.236257C11.851 -0.0786648 11.3387 -0.0786649 11.023 0.236256L3.82784 7.42899C3.51691 7.74066 3.51691 8.26021 3.82864 8.57107Z"
        fill="#18A0FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_62074_60433">
        <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(-180)" />
      </clipPath>
    </defs>
  </svg>
);

const arrowRightIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M12.1694 7.42893L4.97428 0.23619C4.65857 -0.07873 4.14705 -0.07873 3.83054 0.23619C3.51482 0.55111 3.51482 1.06262 3.83054 1.37754L10.455 7.99957L3.83134 14.6216C3.51562 14.9365 3.51562 15.448 3.83134 15.7637C4.14705 16.0787 4.65936 16.0787 4.97508 15.7637L12.1702 8.57101C12.4811 8.25934 12.4811 7.73979 12.1694 7.42893Z"
      fill="#18A0FB"
    />
  </svg>
);

export default function Tabs({
  tabs = [],
  selectedTab,
  variant = 'primary',
  isVertical = false,
  uppercase = false,
  className = '',
  tabClassName = '',
  onChange,
}) {
  const scrollElement = useRef(null);
  const [canScrollToLeft, setCanScrollToLeft] = useState(false);
  const [canScrollToRight, setCanScrollToRight] = useState(tabs.length > 0); // if there are some tabs this will be true
  const [activeTab, setActiveTab] = useState(selectedTab);

  useEffect(() => {
    // if the parent has an event that change the value of the selectedTab
    if (selectedTab) {
      setActiveTab(selectedTab);
    } else if (tabs && tabs.length > 0) {
      // otherwise we select the first tab
      setActiveTab(tabs[0]);
    }
  }, [selectedTab, tabs]);

  const handleSelectChange = (tab) => {
    if (tab.key !== activeTab.key) {
      setActiveTab(tab);
      if (onChange) {
        onChange(tab);
      }
    }
  };

  const handleScroll = (direction) => {
    const element = scrollElement.current;
    const elementWidth = (element?.scrollWidth || 0) - (element?.clientWidth || 0);

    if (element) {
      if (direction === 'right' && canScrollToRight) {
        scrollElement.current.scrollLeft += 100;
      } else if (direction === 'left' && canScrollToLeft) {
        scrollElement.current.scrollLeft -= 100;
      }

      setCanScrollToLeft(element.scrollLeft > 0);
      setCanScrollToRight(element.scrollLeft < elementWidth);
    }
  };

  const isPrimaryVariant = variant === 'primary' && !isVertical;
  const classes = classNames(tabContainerVariants({ variant, isVertical }), className);
  const containerClasses = classNames({ [styles.container]: isPrimaryVariant });

  return (
    <div className={containerClasses}>
      {/* {isPrimaryVariant && (
        <Button
          size="icon"
          variant="secondary"
          isDisabled={!canScrollToLeft}
          onClick={() => handleScroll('left')}
          className={styles.navigationButton}
        >
          {arrowLeftIcon}
        </Button>
      )} */}

      <div role="tablist" className={classes} ref={scrollElement}>
        {tabs?.map((tab) => (
          <Tab
            tab={tab}
            variant={variant}
            isActive={activeTab?.key === tab.key}
            uppercase={uppercase}
            className={tabClassName}
            onSelect={(t) => handleSelectChange(t)}
          />
        ))}
      </div>

      {/* {isPrimaryVariant && (
        <Button
          size="icon"
          isDisabled={!canScrollToRight}
          onClick={() => handleScroll('right')}
          className={styles.navigationButton}
        >
          {arrowRightIcon}
        </Button>
      )} */}
    </div>
  );
}
